<template>
    <h1>{{ $t('menu.users.subpages.addUser.header') }}</h1>

    <div>
        <button class="appButton mt-2" @click="this.$router.push('/users')">{{ $t('menu.users.subpages.addUser.back') }}</button>
        <button class="appButton mt-2" @click="saveUser()">{{ $t('menu.users.subpages.addUser.save') }}</button>
    </div>

    <div class="flex flex-row">
        <div class="w-1/4">
            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.users.subpages.addUser.name') }}</label><br/>
                <input class="p-2 w-64" type="text" v-model="row1.name">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.users.subpages.addUser.email') }}</label><br/>
                <input class="p-2 w-64" type="text" v-model="row1.email">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.users.subpages.addUser.password') }}</label><br/>
                <input class="p-2 w-64" type="text" v-model="row2.password">
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.users.subpages.addUser.confirm_password') }}</label><br/>
                <input class="p-2 w-64" type="text" v-model="row2.confirm_password">
            </div>

        </div>
        <div class="w-1/4">
            <div class="pt-4 pb-4">
                <label for="department_p_id">{{ $t('menu.users.subpages.addUser.department') }}</label><br/>
                <select class="p-2 w-64" v-model="row1.department_p_id">
                    <option v-for="department in user.departments" :key="department.p_id" :value="department.p_id">{{ department.name }}</option>
                </select>
            </div>

            <div class="pt-4 pb-4">
                <label for="role_p_id">{{ $t('menu.users.subpages.addUser.user_role') }}</label><br/>
                <select class="p-2 w-64" v-model="row1.user_role">
                    <option v-for="role in user.roles" :key="role.p_id" :value="role.p_id">{{ role.name }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();

        return { user }
    },
    data() {
        return {
            row1: { 
                'department_p_id': '',
                'user_role': '',
                'name': '',
                'email': ''
                },
            row2: {
                'password': '',
                'confirm_password': ''
                },
        }
    },
    components: {
        
    },
    methods: {
        async saveUser() {
            const data = {
                department_p_id: this.row1.department_p_id,
                user_role: this.row1.user_role,
                name: this.row1.name,
                email: this.row1.email,
                password: this.row2.password,
                confirm_password: this.row2.confirm_password,
            }

            if (data.password !== data.confirm_password) {
                alert(this.$t('common.passwordsDoNotMatch'));
                return;
            } else {
                await this.user.saveUser(data);
                this.$router.push({ name: 'users' });
            }
        }
    }
}
</script>